import { CircularProgress } from "@mui/material";
import React from "react";

export const CircularLoader = ({ sx, ...props }) => {
  return (
    <div>
      <CircularProgress  sx={{ ...sx }} />
    </div>
  );
};
